import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiX, FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { RiMenu3Fill } from "react-icons/ri";

const NavbarTwo = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 z-50 font-signika w-full">
      {/* ================= TOPBAR ================= */}
      <div className="hidden md:flex justify-between items-center bg-gray-100 text-gray-600 text-sm px-6  py-2 ">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2 ">
            <BsTelephoneFill /> +6285655556864
          </div>
          <div className="flex items-center gap-2 ">
            <MdEmail /> admin@patunganindonesia.com
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="mr-2">Follow Us On:</span>
          <FiFacebook className="cursor-pointer" />
          <FiInstagram className="cursor-pointer" />
          <FiYoutube className="cursor-pointer" />
        </div>
      </div>

      {/* ================= MAIN NAVBAR ================= */}
      <div className="bg-white shadow-sm">
        <div className=" px-4 md:px-6 lg:px-10 h-[74px] flex items-center justify-between">
          {/* LOGO */}
          <NavLink to="/" className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Dumai" className="h-10 md:h-12 object-contain" />
          </NavLink>

          {/* MENU DESKTOP */}
          {/* <nav className="hidden lg:flex items-center gap-8 text-gray-700 font-medium">
            <NavLink to="/" className="hover:text-green-600">
              Beranda
            </NavLink>
            <NavLink to="/umkm" className="hover:text-green-600">
              UMKM
            </NavLink>
            <NavLink to="/" className="hover:text-green-600">
              Berita
            </NavLink>
            <NavLink to="/" className="hover:text-green-600">
              Perangkat Daerah
            </NavLink>
            <NavLink to="/" className="hover:text-green-600">
              CCTV
            </NavLink>
            <NavLink to="/" className="hover:text-green-600">
              E-Government
            </NavLink>
            <NavLink to="/" className="hover:text-green-600">
              FAQ
            </NavLink>
          </nav> */}

          {/* RIGHT BUTTON */}
          <div className="hidden lg:flex items-center gap-3">
            <NavLink to="https://patunganindonesia.online/login/inspirator" className="bg-secondary hover:bg-green-800 text-white px-6 py-2.5 rounded-full font-semibold transition">
              Masuk
            </NavLink>

            <NavLink to="https://patunganindonesia.online/inspirator/register" className="border border-secondary text-secondary hover:bg-green-800  px-6 py-2.5 rounded-full font-semibold transition">
              Daftar
            </NavLink>
          </div>

          {/* HAMBURGER */}
          <button className="lg:hidden" onClick={() => setOpen(!open)}>
            {open ? <FiX size={28} /> : <RiMenu3Fill size={28} />}
          </button>
        </div>
      </div>

      {/* ================= MOBILE MENU ================= */}
      <div className={`lg:hidden fixed top-[74px] left-0 w-full bg-white shadow-md transition-all duration-300 ${open ? "max-h-screen py-6" : "max-h-0 overflow-hidden"}`}>
        <div className="flex flex-col items-center gap-5 text-gray-700 font-medium">
          {/* <NavLink to="/" onClick={() => setOpen(false)}>
            Beranda
          </NavLink>
          <NavLink to="/umkm" onClick={() => setOpen(false)}>
            UMKM
          </NavLink>
          <NavLink to="/" onClick={() => setOpen(false)}>
            Berita
          </NavLink>
          <NavLink to="/" onClick={() => setOpen(false)}>
            Perangkat Daerah
          </NavLink>
          <NavLink to="/" onClick={() => setOpen(false)}>
            CCTV
          </NavLink>
          <NavLink to="/" onClick={() => setOpen(false)}>
            E-Government
          </NavLink>
          <NavLink to="/" onClick={() => setOpen(false)}>
            FAQ
          </NavLink> */}

          <NavLink to="/" className=" text-primary2 px-6 py-2 rounded-full" onClick={() => setOpen(false)}>
            Beranda
          </NavLink>

          <NavLink to="https://patunganindonesia.online/login/inspirator" className="bg-green-700 text-white px-6 py-2 rounded-full" onClick={() => setOpen(false)}>
            Masuk
          </NavLink>
          <NavLink to="https://patunganindonesia.online/inspirator/register" className="border border-secondary text-secondary hover:bg-green-800  px-6 py-2.5 rounded-full font-semibold transition">
            Daftar
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default NavbarTwo;
